"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  KALTURA: 'KALTURA',
  NEWROW: 'NEWROW',
  WEBCASTING: 'WEBCASTING',
  EXTERNAL: 'EXTERNAL',
  EMBEDDED: 'EMBEDDED',
  SIMULIVE: 'SIMULIVE',
  VIDEO_PROVIDER: 'VIDEO_PROVIDER',
  INTERACTIVE_VIDEO_PROVIDER: 'INTERACTIVE_VIDEO_PROVIDER',
  ZOOM: 'ZOOM'
};
exports.default = _default;